
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material'

import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa";
import { TbStack2 } from "react-icons/tb";
import { AiOutlineLineChart, AiOutlineClockCircle, AiOutlineUnorderedList, AiOutlineCheckCircle, } from "react-icons/ai";
import { Clock, Running, RectangleList, Plus } from "../../common/CustomIcons";

import VideoFeed from "../../common/VideoFeed";
import LoadingAnimation from "../../common/LoadingAnimation";
import PaddedContentArea from "../../common/PaddedContentArea";
import LoadingAnimation2 from "../../common/LoadingAnimation2";

import { GetPendingWorkout, SetWorkout, GetWholeWorkoutByProgram, SetSelectedWorkout, SendPostWorkoutNotification } from "../../redux/v2/workout/actions";
import { GetAllWorkOutHistories, AddProgram, GetSelectionHistory, GetAllWorkOutHistoriesWithArchived, } from "../../redux/v2/user/actions";

import { programLevels } from "../../constants";
import { delay } from "../../utils";
import { ScreenType } from "../../utils/breakpoints";
import MetaIcons from "../program-detail/MetaIcons";

import "./style.css";
import Upnext from "./components/Upnext";
import CustomSlider from "../../common/CustomSlider";
import PostWorkoutMessage from "./components/PostWorkoutMessage";
import CustomButton from "../../common/CustomButton";

import useSVG from "../../hooks/useSVG";

function WorkoutV3(props) {
    const navigate = useNavigate()
    const { UseEssentialsSVG } = useSVG();
    const screenSize = ScreenType(useMediaQuery);

    const [videoAddionalDetails, setVideoAddionalDetails] = useState(null);
    const [activeInfo, setActiveInfo] = useState("all");
    const [currentProgram, setCurrentProgram] = useState(null);
    const [addingStatus, setAddingStatus] = useState(0); // 0 no, 1 loading, 2 success
    const [clicked, setClicked] = useState(false);
    const [showSlider, setShowSlider] = useState(false); // 0 no, 1 loading, 2 success

    const { programs } = props.Program;
    const { user, allWorkoutHistory, selectedPrograms } = props.User;
    const { groupedWorkouts, pendingWorkout } = props.Workout;

    const viewType = new URLSearchParams(window.location.search).get("view-type");
    const workoutID = new URLSearchParams(window.location.search).get("workout");

    // const hist = selectedPrograms.filter(sp => sp.program_id == pendingWorkout?.program_id && sp.level == pendingWorkout?.program_detail_id);
    // let programHistory = allWorkoutHistory.filter(wh => wh.program == pendingWorkout?.program_id && wh.level == pendingWorkout?.program_detail_id && new Date(wh.created_at) >= new Date(hist?.[0]?.created_at));

    useEffect(async () => {
        props.GetSelectionHistory();
        props.GetAllWorkOutHistories();
        props.GetAllWorkOutHistoriesWithArchived();
    }, []);

    useEffect(async () => {
        if (workoutID) {
            const res = await props.SetWorkout(workoutID);
        }
        // props.GetAllWorkOutHistories();

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })

    }, [workoutID]);

    useEffect(async () => {
        if (programs.length && !currentProgram && pendingWorkout?.id) {
            let temp = programs.filter(p => p.id == pendingWorkout.program_id);
            setCurrentProgram(temp[0])
        }
    }, [programs, pendingWorkout]);

    useEffect(async () => {
        if (pendingWorkout?.id) {
            props.GetWholeWorkoutByProgram(pendingWorkout.program_id, pendingWorkout.program_detail_id);
        }
    }, [pendingWorkout]);

    useEffect(() => {
        if (screenSize != "xl") {
            setActiveInfo("all");
        } else {
            setActiveInfo("all");
        }
    }, [screenSize])

    useEffect(() => {
        if (currentProgram && user?.selected_program) {
            // setShowSlider(true);
            let temp = user?.selected_program?.split(",") || [];
            if (temp.includes(currentProgram.id + "")) {
                if (addingStatus == 0) {
                    setAddingStatus(3);
                } else if (addingStatus == 2) {
                    delay(() => {
                        setAddingStatus(3);
                    }, 2000);
                }
            }
        }

    }, [user?.selected_program, addingStatus, currentProgram]);

    const isPreview = viewType && viewType == "preview" ? true : false;

    const key = ("prog-" + pendingWorkout?.program_id) + ((pendingWorkout?.program_detail_id && pendingWorkout?.program_detail_id != 0) ? ("-" + pendingWorkout?.program_detail_id) : "");
    const progWorkouts = groupedWorkouts[key] || [];
    const programLevel = programLevels[pendingWorkout?.program_detail_id];

    const ActionButton = () => {
        return (
            <>
                <div id="pdab-add-btn" onClick={async () => {
                    if (addingStatus == 0) {
                        setAddingStatus(1);
                        const res = await props.AddProgram(currentProgram?.id, pendingWorkout?.program_detail_id);
                        if (res.success) {
                            setAddingStatus(2);
                        } else {
                            setAddingStatus(0);
                            toast.error('Failed to add Program');
                        }
                    } else if (addingStatus == 3) {
                        if (progWorkouts.length) {
                            navigate("/workout?workout=" + progWorkouts[0].id)
                        }
                    }
                }}>
                    {
                        addingStatus == 0 &&
                        <div id="pdab-add-btn-wrapper" className="g-orange">
                            <div className="btn-wrp flex-c">
                                <div className="btn-cont">
                                    <FaPlus />
                                </div>
                            </div>
                            <h6>ADD PROGRAM</h6>
                        </div>
                    }

                    {
                        addingStatus == 1 && <LoadingAnimation2 />
                    }

                    {
                        addingStatus == 2 &&
                        <div className="flex-c-full">
                            <AiOutlineCheckCircle style={{ fontSize: "35px" }} />
                        </div>
                    }

                    {
                        addingStatus == 3 &&
                        <div className="flex-c-full">
                            <h4>GET STARTED</h4>
                        </div>
                    }
                </div>
            </>
        )
    }

    let initialSlide = null;

    for (let x = 0; x < progWorkouts.length; x++) {
        if (progWorkouts[x].id == pendingWorkout.id) {
            initialSlide = x + 1;

            if (initialSlide < progWorkouts.length) {
                initialSlide += 1;
            }
        }
    }

    return (
        <div id="workout-v3">
            <div id="program-intro-v2" className="program-detail content-area" style={{ margin: 0 }}>
                <PaddedContentArea>
                    <div id="onb-v2-program-details">
                        <div id="onb-v2-program-video">
                            <div id="onb-v2-video-container">
                                <VideoFeed
                                    setAdditionalDetails={(data) => {
                                        setVideoAddionalDetails(data)
                                    }}
                                    video={pendingWorkout}
                                    favorite={true}
                                    onClose={(data) => {
                                        if (data.progress >= 80) {
                                            delay(() => {
                                                setShowSlider(true);
                                                props.SendPostWorkoutNotification(user, pendingWorkout);
                                            }, 300)
                                        }
                                    }}
                                />
                            </div>

                            {
                                pendingWorkout && currentProgram &&
                                <div id="onb-v2-video-detail">
                                    <div>

                                        {
                                            (activeInfo == "all" || activeInfo == "info") &&
                                            <div className="detail-description">
                                                <h2 id="dd-program-name">{currentProgram?.title} {programLevel ? (" - " + programLevel.toLowerCase()) : ""}</h2>

                                                {
                                                    screenSize != "xl"
                                                        ? <div id="detail-description-icons">
                                                            <div>
                                                                {
                                                                    isPreview
                                                                        ? <>
                                                                            <h4>{pendingWorkout?.workout_number}</h4>
                                                                            <h6>WORKOUTS</h6>
                                                                        </>
                                                                        : <>
                                                                            <h4>{(pendingWorkout?.workout_number + "").padStart(2, "0")}/{progWorkouts?.length}</h4>
                                                                            <h6>WORKOUT</h6>
                                                                        </>
                                                                }

                                                            </div>

                                                            <div>
                                                                <h4>{videoAddionalDetails ? Math.round(videoAddionalDetails?.duration / 60) : ""}m</h4>
                                                                <h6>LENGTH</h6>
                                                            </div>

                                                        </div>
                                                        : <>
                                                            <div id="detail-description-icons2">
                                                                <div>
                                                                    <h5>WORKOUT:</h5>
                                                                    <p>{(pendingWorkout?.workout_number + "").padStart(2, "0")}/{progWorkouts?.length}</p>
                                                                </div>
                                                                <div>
                                                                    <h5>LENGTH:</h5>
                                                                    <p>{videoAddionalDetails ? Math.round(videoAddionalDetails?.duration / 60) : ""}m</p>
                                                                </div>
                                                            </div>
                                                        </>

                                                }



                                                <div>
                                                    <h5>ABOUT</h5>
                                                    <body>
                                                        {pendingWorkout?.description}
                                                    </body>
                                                </div>

                                            </div>
                                        }

                                        {
                                            (activeInfo == "all" || activeInfo == "supp") &&
                                            <div id="whats-needed" className="detail-whats-needed">
                                                <h5>NICE TO HAVE, BUT NOT REQUIRED:</h5>
                                                <div className="item-need-wrap">
                                                    {
                                                        pendingWorkout?.essentials?.map((ess, i) => {
                                                            return (
                                                                <div className="item-need" key={"p-ess-" + i}>
                                                                    <div className="image-part">
                                                                        {UseEssentialsSVG(ess?.svg)}
                                                                    </div>
                                                                    <body>{ess.title}</body>
                                                                </div>
                                                            )
                                                        })
                                                    }

                                                </div>
                                            </div>
                                        }

                                        {
                                            (pendingWorkout && currentProgram && isPreview && screenSize == "xl") &&
                                            <div id="detail-description-actions" style={{ paddingTop: "30px" }}>
                                                {
                                                    addingStatus != 3 &&
                                                    <div>
                                                        <CustomButton onClick={async () => {
                                                            setClicked(true);
                                                            if (!clicked) {
                                                                const toastId = toast.loading("Adding Program...");
                                                                setAddingStatus(1);

                                                                const res = await props.AddProgram(currentProgram?.id, pendingWorkout?.program_detail_id);
                                                                if (res.success) {
                                                                    toast.success('Program Added', {
                                                                        id: toastId,
                                                                    });
                                                                    setAddingStatus(2);

                                                                } else {
                                                                    setAddingStatus(0);
                                                                    setClicked(false);
                                                                    toast.error('Failed to add Program', {
                                                                        id: toastId,
                                                                    });

                                                                }
                                                            }
                                                        }} className="active">
                                                            <Plus />Add Program
                                                        </CustomButton>
                                                    </div>
                                                }

                                                {
                                                    addingStatus == 3 &&
                                                    <div>
                                                        <CustomButton onClick={() => {
                                                            setClicked(false);
                                                            navigate("/workout?workout=" + progWorkouts[0].id)
                                                        }} className="active">
                                                            Get Started
                                                        </CustomButton>
                                                    </div>
                                                }



                                            </div>

                                        }

                                    </div>
                                </div>
                            }

                            {
                                !(pendingWorkout && currentProgram) &&
                                <div style={{ width: "100%", marginTop: "50px" }} className="flex-c">
                                    <LoadingAnimation />
                                </div>
                            }

                        </div>

                        {
                            (pendingWorkout && currentProgram && isPreview) &&
                            <div id="program-details-action-button">
                                <ActionButton />
                            </div>
                        }


                    </div>
                </PaddedContentArea>
            </div>
            {
                !isPreview && <Upnext viewedWorkout={workoutID} program={currentProgram?.id} level={pendingWorkout?.program_detail_id} workouts={progWorkouts || []} screenSize={screenSize} initialSlide={initialSlide} />
            }

            <CustomSlider show={showSlider} setShowSlider={() => {
                setShowSlider(false);
                navigate("/home")
            }}>
                {(showSlider) && <PostWorkoutMessage workout={pendingWorkout} />}
            </CustomSlider>
        </div >
    );
}


const mapStateToProps = (state) => ({
    Program: state.Program,
    Workout: state.Workout,
    User: state.User,
});

export default connect(mapStateToProps, {
    GetPendingWorkout,
    GetWholeWorkoutByProgram,
    GetSelectionHistory,
    SetSelectedWorkout,
    SetWorkout,
    GetAllWorkOutHistories,
    AddProgram,
    GetAllWorkOutHistoriesWithArchived,
    SendPostWorkoutNotification,
})(WorkoutV3);